import {
    createFeatureSelector,
    createReducer,
    createSelector,
    on,
    StoreModule,
} from '@ngrx/store';
import { GeoCoordinate } from '@polaris-customerweb/sharedcomponents.shared';
import { EffectLoadingState } from '../shared/models/effect-state';
import { EffectStateBase } from '../shared/models/effect-state-base';
import {
    GetUserLocation,
    GetUserLocationFail,
    GetUserLocationSuccess,
} from './user-location.actions';

export const userLocationFeatureKey = 'userLocationState';

export interface UserLocationState extends EffectStateBase {
    location: GeoCoordinate | null;
}

export const initialState: UserLocationState = {
    effectState: EffectLoadingState.Init,
    location: null,
};

export const selectUserLocationFeature =
    createFeatureSelector<UserLocationState>(userLocationFeatureKey);

export const selectUserLocation = createSelector(
    selectUserLocationFeature,
    (state: UserLocationState) => state
);

export const userLocationReducer = createReducer(
    initialState,
    on(GetUserLocation, (state) => ({
        ...state,
        effectState: EffectLoadingState.Loading,
    })),
    on(GetUserLocationSuccess, (state, { location }) => ({
        ...state,
        effectState: EffectLoadingState.Loaded,
        location,
    })),
    on(GetUserLocationFail, (state, { errorMessage }) => ({
        ...state,
        effectState: { errorMessage },
    }))
);

export const userLocationStoreModule = StoreModule.forFeature(
    userLocationFeatureKey,
    userLocationReducer
);
